import React, { useState } from 'react';
import classes from "./LoginZipGame.module.css";
import Header from '../../components/Header';
import ZipGameStepperLogin from '../../components/ZipGameStepperLogin';
import { useNavigate } from 'react-router-dom';
import { loginZipUser } from '../../http/http';
import { useDispatch } from 'react-redux';
import { setUserZip } from '../../store/slices/userZipGameTokenSlice';
import { toast } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa6';

const LoginZipGame = () => {
    const [msisdn, setMsisdn] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleNext = async () => {
        if (!msisdn.trim()) return;

        try {
            // hit here the api for user login

            const response = await loginZipUser(msisdn);
            console.log(response?.data?.result, 'response-');

            if (response?.data?.result?.loginStatus == 1) {


                // user is login success
                navigate("/login/verify-otp/zip-game", {
                    state: { msisdn },
                });
            }
            else {
                // you are not registered!
                toast.error('You are not registered! Please Register First!');
            }


        } catch (error) {
            console.log(error, 'error-');
            toast.error(error?.response?.data?.message || "Something Went Wrong! Try Again!");
        }

    };

    return (
        <>
            <Header />

            <div className={classes.container}>

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>
                </div>


                <div className={classes.heroCard}>
                    <div className={classes.heroBadge}>ZIP GAME</div>
                    <h1 className={classes.heroTitle}>Login & Play for Free</h1>
                    <p className={classes.heroText}>
                        Enter your registered number to start your Zip Game and get the
                        chance to win rewards.
                    </p>
                </div>

                <ZipGameStepperLogin currentStep={1} />

                <div className={classes.formCard}>
                    <div className={classes.section}>
                        <div className={classes.sectionHead}>
                            <h2 className={classes.sectionTitle}>Enter Mobile Number</h2>
                            <p className={classes.sectionText}>
                                Please enter your number to continue.
                            </p>
                        </div>

                        <div className={classes.inputGroup}>
                            <label className={classes.label} htmlFor="msisdn">
                                Mobile Number
                            </label>

                            <div className={classes.phoneField}>
                                <div className={classes.countryBox}>
                                    <img
                                        src="/assets/images/papua.png"
                                        alt="flag"
                                        className={classes.flag}
                                    />
                                    <span className={classes.code}>+675</span>
                                </div>

                                <input
                                    id="msisdn"
                                    type="number"
                                    className={classes.input}
                                    placeholder="Enter mobile number"
                                    value={msisdn}
                                    onChange={(e) => setMsisdn(e.target.value)}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        </div>

                        <div className={classes.infoBox}>
                            <p>
                                We will send a one-time password to this number for verification.
                            </p>
                        </div>

                        <button type="button" className={classes.primaryBtn} onClick={() => handleNext()}>
                            Send OTP
                        </button>

                        {/* here it will be the register option */}
                        <p className={classes.link_text}>
                            New User?{" "}<span onClick={() => navigate("/register/zip-game")}>Register Here</span>
                        </p>

                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginZipGame